import React from "react";
import AutomobileToughnessGlassBanner from "../../../Assets/Product_Images/automobiletoughnessglass/AutomobileToughnessGlassBanner.jpg";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Automotive_Glass1 from "../../../Assets/Product_Images/automobiletoughnessglass/AutomobileToughnessGlass1.png";
import Automotive_Glass2 from "../../../Assets/Product_Images/automobiletoughnessglass/AutomobileToughnessGlass2.png";
import Automotive_Glass3 from "../../../Assets/Product_Images/automobiletoughnessglass/AutomobileToughnessGlass3.png";
import Automotive_Glass4 from "../../../Assets/Product_Images/automobiletoughnessglass/AutomobileToughnessGlass4.png";
import Automotive_Glass5 from "../../../Assets/Product_Images/automobiletoughnessglass/AutomobileToughnessGlass5.png";
import Automotive_Glass6 from "../../../Assets/Product_Images/automobiletoughnessglass/AutomobileToughnessGlass6.png";
import { Link } from "react-router-dom";

const Automobile_Toughness_Glass = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${AutomobileToughnessGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white"> Automotive Toughened Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5
                  style={{
                    color: "#153fa4",
                    fontFamily: "Segoe UI, sans-serif",
                    fontSize: "40px",
                    fontWeight: "700",
                    marginBottom: "15px",
                  }}
                >
                  Automotive Toughened Glass
                </h5>
                <p>
                  Commonly known as tempered or toughened glass, automobile
                  toughness glass is a specially modified safety glass used
                  largely for vehicle windows and windshields. This kind of
                  glass is strengthened by a regulated thermal or chemical
                  process over ordinary glass. By ensuring that the tempered
                  glass breaks into tiny, blunt pieces, the tempering process
                  helps to lower passenger injury risk.
                </p>

                <p>
                  Particularly vital for
                  automobile side and rear windows, this glass combines safety
                  with durability. Because it withstands thermal stress and
                  impacts, it is perfect for automobile usage, where
                  environmental changes and little collisions are frequent. The
                  toughness of the glass also improves security since it is more
                  challenging to break, therefore discouraging theft.
                </p>

                <p>
                  In contemporary automotive design, tough glass enhances both
                  aesthetics and utility. It aids several coatings for tinting
                  for temperature control, privacy, and UV protection. Its
                  synergy of strength, safety, and extra amenities makes it a
                  mainstay in global automobile production.
                </p>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                <img src={Automotive_Glass1} style={{width : "180px" , height : "180px"}} alt="Bus" />
                <img src={Automotive_Glass2} style={{width : "180px" , height : "180px"}} alt="car" />
                <img src={Automotive_Glass3} style={{width : "180px" , height : "180px"}} alt="staff-bus" />
                <img src={Automotive_Glass4} style={{width : "180px" , height : "180px"}} alt="staff-bus" />
                <img src={Automotive_Glass5} style={{width : "180px" , height : "180px"}} alt="staff-bus" />
                <img src={Automotive_Glass6} style={{width : "180px" , height : "180px"}} alt="staff-bus" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End  */}

      <Footer />
    </div>
  );
};

export default Automobile_Toughness_Glass;
